import { Component, OnInit } from '@angular/core';
import { UtilService } from 'src/app/services/util.service';
import { MainService } from 'src/app/services/main.service';

@Component({
    selector: 'app-support-portal',
    templateUrl: './support-portal.component.html',
    styleUrls: ['./support-portal.component.css'],
    standalone: false
})
export class SupportPortalComponent implements OnInit {

  constructor(public uitlService: UtilService,public mainService: MainService) { }

  ngOnInit(): void {
    this.uitlService.showNavigationBar.next(false);
        // get auth-code from url if present
       let params= this.uitlService.getUrlParams();
       if(params["code"])
       {
        this.uitlService.getAuthcode.next(params["code"]!);
       }
  }

}
